import * as React from 'react';
import { WithStyles, withStyles, IconButton,} from '@material-ui/core';
import { IEcoPurchase, IEcoTransfer, IEcoSplitSetting} from "@app-types/websocket/economy.types";
import {IFamilyMember} from "@app-types/websocket/family.types";
import TranslateNew from "@translate/TranslateNew";
import { ecoContainerStyle } from './Container.style';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { IEcoMonthlyPurchases } from '@containers/economy/economy.internal.types';
import { getPurchaseBalance, getTransferBalance } from '@helpers/EconomyHelper';
import ListItemPurchase from './ListItemPurchase';
import ListItemTransfer from './ListItemTransfer';
import { styleColors } from 'src/main.style';

const tn = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof ecoContainerStyle>
{
    transactionsByMonth: IEcoMonthlyPurchases[];
    purchases: IEcoPurchase[];
    transfers: IEcoTransfer[];
    family: IFamilyMember[];
    userId:number;
    settings:IEcoSplitSetting[];
    currency:string;

    edit: (purchase:IEcoPurchase) => void;
    editTransfer: (transfer:IEcoTransfer) => void;
    seen: (purchaseId:number) => void;
    seenTransfer: (transferId:number) => void;

    scrollTime:number;

    waitForPurchaseChat:(id:number) => void;
    waitForTransferChat:(id:number) => void;
}

interface IState
{
    monthIndex:number;
}

class ContainerDoneTransactions extends React.Component<IProps,IState> {

    constructor(props: IProps) {
        super(props);
    
        this.state = {
            monthIndex:0,
        };
    
    }

    public componentDidUpdate(prevProps: Readonly<IProps>): void {
        let elementName: string = "";
        if (prevProps.purchases !== undefined && prevProps.purchases.length === (this.props.purchases.length -1)) {
            for (const p of this.props.purchases) {
                if (prevProps.purchases.findIndex((op) => op.id === p.id) === -1) {
                    if ((Date.now() - p.date) < 10000 ) {
                        elementName = "pur"+p.id;
                    }
                    break;
                }
            }
        } else if (prevProps.transfers !== undefined && prevProps.transfers.length === (this.props.transfers.length -1)) {
            for (const t of this.props.transfers) {
                if (prevProps.transfers.findIndex((ot) => ot.id === t.id) === -1) {
                    if ((Date.now() - t.date) < 10000 ) {
                        elementName = "tra"+t.id;
                    }
                    break;
                }
            }
        }
        if (elementName !== "") {
            setTimeout(() => {
                const elmnt = document.getElementById(elementName);
                if (elmnt !== null) {
                    elmnt.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 500);
        }
    }

    public render()
    {
        const { classes, transactionsByMonth, userId, family,settings, currency, scrollTime, edit, editTransfer, seen, seenTransfer } = this.props;
        const { monthIndex } = this.state;

        const thisMonthsPurchases:IEcoPurchase[] = (transactionsByMonth.length >= monthIndex && transactionsByMonth[monthIndex] !== undefined) 
            ? transactionsByMonth[monthIndex].purchases: [];
        const thisMonthsTransfers:IEcoTransfer[] = (transactionsByMonth.length >= monthIndex && transactionsByMonth[monthIndex] !== undefined) 
            ? transactionsByMonth[monthIndex].transfers: [];
        const thisMonth:string = (transactionsByMonth.length >= monthIndex && transactionsByMonth[monthIndex] !== undefined) 
            ? (tn.lang.getMonthName(transactionsByMonth[this.state.monthIndex].month))
            : tn.lang.unknown;
        const thisYear:string = (this.props.transactionsByMonth.length >= monthIndex && transactionsByMonth[monthIndex] !== undefined) 
            ? (""+(transactionsByMonth[this.state.monthIndex].year))
            : "";
        
        const monthBalance:{spent:number,balance:number} = {spent:0,balance:0};
        thisMonthsPurchases.sort((a,b) => a.date-b.date);
        thisMonthsTransfers.sort((a,b) => a.date-b.date);

        let pIndex = 0;
        let tIndex = 0;
        const transactions:JSX.Element[] = [];
        const deletedTransactions:JSX.Element[] = [];
        while (pIndex < thisMonthsPurchases.length || tIndex < thisMonthsTransfers.length) {
            if (pIndex < thisMonthsPurchases.length && tIndex < thisMonthsTransfers.length) {
                if (thisMonthsPurchases[pIndex].date < thisMonthsTransfers[tIndex].date) {
                    const purchase = thisMonthsPurchases[pIndex];
                    if (!purchase.deleted) {
                        const balance = getPurchaseBalance(purchase,userId,this.props.settings);
                        monthBalance.balance = monthBalance.balance + balance;
                        monthBalance.spent = monthBalance.spent + purchase.amount;
                    }
                    (purchase.deleted ? deletedTransactions : transactions).push(
                        <ListItemPurchase  key={"p"+purchase.id} currency={currency} family={family} userId={userId}
                        waitForPurchaseChat={this.props.waitForPurchaseChat}
                        settings={settings} edit={edit} purchase={purchase} seen={seen} scrollTime={scrollTime}/>);
                    pIndex+=1;
                } else {
                    const transfer = thisMonthsTransfers[tIndex];
                    if (!transfer.deleted) {
                        const balance = getTransferBalance(transfer, userId, this.props.settings);
                        monthBalance.balance = monthBalance.balance + balance;
                    }
                    (transfer.deleted ? deletedTransactions : transactions).push(
                        <ListItemTransfer currency={currency} family={family} userId={userId} scrollTime={scrollTime}
                        waitForTransferChat={this.props.waitForTransferChat}
                        settings={settings} key={"t"+transfer.id} editTransfer={editTransfer} transfer={transfer} seenTransfer={seenTransfer}/>);
                    tIndex+=1;
                }
            } else if (pIndex < thisMonthsPurchases.length) {
                const purchase = thisMonthsPurchases[pIndex];
                if (!purchase.deleted) {
                    const balance = getPurchaseBalance(purchase,userId,this.props.settings);
                    monthBalance.balance = monthBalance.balance + balance;
                    monthBalance.spent = monthBalance.spent + purchase.amount;
                }
                (purchase.deleted ? deletedTransactions : transactions).push(
                    <ListItemPurchase key={"p"+purchase.id} currency={currency} family={family} userId={userId}
                    waitForPurchaseChat={this.props.waitForPurchaseChat}
                    settings={settings} edit={edit} purchase={purchase} seen={seen} scrollTime={scrollTime}/>);
                pIndex+=1;
            } else if (tIndex < thisMonthsTransfers.length) {
                const transfer = thisMonthsTransfers[tIndex];
                if (!transfer.deleted) {
                    const balance = getTransferBalance(transfer, userId, this.props.settings);
                    monthBalance.balance = monthBalance.balance + balance;
                }
                (transfer.deleted ? deletedTransactions : transactions).push(
                    <ListItemTransfer currency={currency} family={family} userId={userId} scrollTime={scrollTime}
                    waitForTransferChat={this.props.waitForTransferChat}
                    settings={settings}  key={"t"+transfer.id} editTransfer={editTransfer} transfer={transfer} seenTransfer={seenTransfer}/>);
                tIndex+=1;
            }
        }            
        const monthBalanceColor = monthBalance.balance > 0
            ? styleColors.callGreen
            : monthBalance.balance < 0 ? styleColors.coralRed : styleColors.greyDark2;

        return (
            <div className={classes.container} style={{flexDirection: 'column',flexWrap:'unset',paddingBottom:260}}>
                <div className={classes.card}>
                    <div className={classes.monthHeader}>
                        <IconButton disabled={(monthIndex >= (transactionsByMonth.length - 1))} 
                            onClick={() => this.setState({monthIndex:(monthIndex+1)})}>
                            <ArrowBack />
                        </IconButton>
                        <span>{thisMonth + " " + thisYear}</span>
                        <IconButton disabled={(monthIndex <= 0)} onClick={() => this.setState({monthIndex:(monthIndex-1)})}>
                            <ArrowForward />
                        </IconButton>
                    </div>
                    {transactions}
                    <div className={classes.monthHeader} style={{textTransform: 'none', lineHeight: '20px', marginTop: '18px'}}>
                        <span>{tn.lang.ecoBalanceMonth}</span>
                        <span style={{color: monthBalanceColor}}>
                            {tn.formatNumber(monthBalance.balance, this.props.currency)}
                        </span>
                    </div>
                    <div className={classes.monthHeader} style={{color: styleColors.warmGrey, fontWeight: 400, fontSize: '11px'}}>
                        <span>{tn.lang.ecoBalanceTotalSpent(thisMonth)}</span><span>{tn.formatNumber(monthBalance.spent, this.props.currency)}</span>
                    </div>
                    {deletedTransactions.length > 0 &&
                        <>
                            <div className={classes.monthHeader}
                                style={{textTransform: 'none', lineHeight: '20px', marginTop: '18px',
                                    paddingTop: '5px', borderTop: '1px solid #ccc'}}>
                                <span>{tn.lang.ecoNotIncluded}</span>
                            </div>
                            {deletedTransactions}
                        </>}

                </div>
            </div>
        );
    }
}

export default withStyles(ecoContainerStyle)(ContainerDoneTransactions);



// WEBPACK FOOTER //
// ./src/components/economy/ContainerDoneTransactions.tsx